// extracted by mini-css-extract-plugin
module.exports = {"labelError":"LabelError-module--labelError--3k_D_"};